import { useSelector as useReduxSelector, useDispatch as useReduxDispatch, TypedUseSelectorHook } from 'react-redux';
import { reviewer } from 'store';

export const useSelector: TypedUseSelectorHook<reviewer.RootState> = useReduxSelector;
export const useDispatch = () => useReduxDispatch<reviewer.AppDispatch>();
